import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";

const MoreOptions = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                onClick={handleClick}
                aria-haspopup="true"
                aria-controls="long-menu"
            >
                <MoreVertIcon />
            </IconButton>
            <Menu anchorEl={anchorEl} keepMounted onClose={handleClose} open={open}>
                {props.optionFor === "patient" ? (
                    [
                        <MenuItem key="edit" onClick={props.handleUpdate}>Edit</MenuItem>,
                        <MenuItem key="delete" onClick={props.handleDelete}>Delete</MenuItem>
                    ]
                ) : null}
            </Menu>
        </div>
    );
};

export default MoreOptions;